<template>
  <ModalForm
    title="Add Passenger"
    :show="props.show"
    @submit="submit"
    @close="emit('close')"
    :processing="form.processing"
  >
    <div class="space-y-4">
      <LabelErrorContainer label="Name">
        <SelectSearch
          instant
          v-model="form.user"
          @search="search"
          :options="options"
          placeholderKey="name"
          allowEmptyValue
          v-slot="{ option, selected }"
        >
          <SelectListItemSimple
            :option="option"
            :selected="selected"
            primaryKey="name"
          />
        </SelectSearch>
      </LabelErrorContainer>
      <div v-if="form.user && (!form.user.id || !form.user.email)">
        <InputGroup
          v-model="form.email"
          type="email"
          label="Email"
          :error="form.errors.email"
        />
        <InputHelpText
          >Enter this person's email if you would like them to receive trip
          notifications.</InputHelpText
        >
      </div>
    </div>
  </ModalForm>
</template>

<script setup>
import ModalForm from '@/Common/Overlays/Modals/ModalForm.vue'
import LabelErrorContainer from '@/Common/Forms/Inputs/LabelErrorContainer.vue'
import SelectSearch from '@/Common/Forms/SelectMenus/SelectSearch.vue'
import SelectListItemSimple from '@/Common/Forms/SelectMenus/SelectListItemSimple.vue'
import { ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import { Inertia } from '@inertiajs/inertia'
import InputGroup from '@/Common/Forms/Inputs/InputGroup.vue'
import InputHelpText from '@/Common/Forms/Inputs/InputHelpText.vue'

const props = defineProps({
  show: Boolean,
  currentFlyers: Array,
  trip: Object,
})

const emit = defineEmits(['close'])

const form = useForm({
  user: null,
  email: null,
})

function submit() {
  form.post(route('trips.add-flyer', props.trip), {
    onSuccess: () => {
      emit('close')
      form.user = null
      form.email = null
      options.value = []
    },
  })
}

// Search
const options = ref([])

let search = _.debounce(function (query) {
  axios
    .get(route('planes.users.search', props.trip.plane), {
      params: {
        query: query,
        except: props.currentFlyers.map((el) => el.id),
        type: 'flyers',
      },
    })
    .then((response) => {
      options.value = response.data
    })
    .catch(() => Inertia.reload())
}, 350)
</script>
